module.exports = __webpack_public_path__ + "static/SizePeople-569cc4745b469e8297efbe801f556002.png";